const router_modular = [
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/HomeView"),
    meta: {
      showTabBar: true, // 显示底部导航栏
      tabIndex: 0, // 对应底部导航栏的索引
      title: "职工观影平台 - 首页",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login"),
    meta: {
      showTabBar: false,
      requiresAuth: false, // 添加此标记表示不需要登录
      title: "职工观影平台 - 登录页",
    },
  },

  {
    path: "/welfarePay/",
    name: "welfarePay",
    component: () => import("@/views/welfarePay"),
    meta: {
      showTabBar: false,
    },
  },
  {
    path: "/my-order",
    name: "my-order",
    component: () => import("@/views/my-order"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/exchange-order",
    name: "exchangeOrder",
    component: () => import("@/views/exchangeOrder"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/card-bind",
    name: "cardBind",
    component: () => import("@/views/cardBind"),
    meta: {
      showTabBar: false, // 显示底部导航栏
      specialBar: true,
    },
  },
  {
    path: "/wx/",
    name: "wx",
    component: () => import("@/views/wx"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/sureOrder",
    name: "sureOrder",
    component: () => import("@/views/sureOrder"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/cardCoupon",
    name: "cardCoupon",
    component: () => import("@/views/cardCoupon"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/pageSearch",
    name: "pageSearch",
    component: () => import("@/views/pageSearch"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/user"),
    meta: {
      showTabBar: true, // 显示底部导航栏
      tabIndex: 3, // 对应底部导航栏的索引
      title: "职工观影平台 - 我的",
    },
  },
  {
    path: "/userInfo",
    name: "userInfo",
    component: () => import("@/views/user/userInfo.vue"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },

  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register"),
    meta: {
      showTabBar: false, // 显示底部导航栏
      requiresAuth: false,
      title: "职工观影平台 - 注册",
    },
  },
  {
    path: "/citySelect",
    name: "citySelect",
    component: () => import("@/views/citySelect"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/aboutMine",
    name: "aboutMine",
    component: () => import("@/views/aboutMine"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/policy"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("@/views/orderDetail"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/cardUsageRecord",
    name: "cardUsageRecord",
    component: () => import("@/views/cardUsageRecord"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
    {
    path: "/cardUsageRecordDetail",
    name: "cardUsageRecordDetail",
    component: () => import("@/views/cardUsageRecordDetail"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/seat",
    name: "seat",
    component: () => import("@/views/seat"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },
  {
    path: "/comingTheater/movies",
    name: "moviesTime",
    component: () => import("@/views/comingTheater/movies"),
    meta: {
      showTabBar: false, // 显示底部导航栏
    },
  },

  {
    path: "/details",
    name: "details",
    component: () => import("@/views/details"),
    meta: {
      showTabBar: false, // 详情页不显示底部导航栏
    },
  },
  {
    path: "/welfare",
    name: "welfare",
    component: () => import("@/views/welfare"),
    meta: {
      showTabBar: true,
      tabIndex: 2,
      title: "职工观影平台 - 福利",
    },
  },
  {
    path: "/films",
    name: "films",
    component: () => import("@/views/films"),
    meta: {
      showTabBar: true,
      tabIndex: 1,
      title: "职工观影平台 - 电影/影院",
    },
  },
  {
    path: "/hone",
    name: "hone",
    component: () => import("@/views/hone"),
  },
  {
    path: "/",
    redirect: "/home", // 修改默认重定向到登录页
  },
];
export default router_modular;
